import { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { T } from '@/components/T';
import { Tabs } from '@teo/components';
import { AuthContext } from '@/components/Contexts/AuthContext';
import SuppottTab from './SupportTab';
import OverviewsTab from './OverviewsTab';
import HelpDeskTab from './HelpDeskTab';
import LicenseTab from './LicenseTab';
import OrganisationStatusToggle from './OrganisationStatusToggle';
import { NavContext } from '@/components/NavContext';
import MobileSubPageMenu from '@/components/HeaderMobile/MobileSubPageMenu';
import { useMobile } from '@/util';

function OrganisationLicensingAndBillingPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState('license');
  const { auth, setAuth } = useContext(AuthContext);
  const { setSubPage } = useContext(NavContext);
  const isMobile = useMobile();

  useEffect(() => {
    setSubPage(true);
    return () => setSubPage(false);
  }, []);

  return (
    <div className="w-full">
      {isMobile ? (
        <div className="mb-2">
          <MobileSubPageMenu
            title={'pages.organisation_licensing_and_billing.title'}
          />
        </div>
      ) : (
        <div className="flex items-center justify-between">
          <h1 className="my-8 text-xl font-semibold text-black">
            <T>{t('pages.organisation_licensing_and_billing.title')}</T>
          </h1>
        </div>
      )}
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div>
          <Tabs activeName={tab} onChange={(tab) => setTab(tab)}>
            <Tabs.TabButton name="license">
              <p className="text-base font-medium">
                {t(
                  'pages.organisation_licensing_and_billing.license.tab_title'
                )}
              </p>
            </Tabs.TabButton>
            <Tabs.TabButton name="support">
              <p className="text-base font-medium">
                {t(
                  'pages.organisation_licensing_and_billing.support.tab_title'
                )}
              </p>
            </Tabs.TabButton>
          </Tabs>
        </div>
        <div className="mt-4 lg:ml-3 lg:mt-0">
          <Tabs activeName={tab} onChange={(tab) => setTab(tab)}>
            <Tabs.TabButton name="overviews">
              <p className="text-base font-medium">
                {' '}
                {t('pages.organisation_licensing_and_billing.overviews_tab')}
              </p>
            </Tabs.TabButton>
            <Tabs.TabButton name="help-desk">
              <p className="text-base font-medium">
                {' '}
                {t('pages.organisation_licensing_and_billing.help_desk_tab')}
              </p>
            </Tabs.TabButton>
          </Tabs>
        </div>
        <OrganisationStatusToggle
          auth={auth}
          className="mt-4 lg:mt-0 lg:ml-auto"
        />
      </div>
      {tab === 'license' && <LicenseTab auth={auth} setAuth={setAuth} />}
      {tab === 'support' && <SuppottTab auth={auth} />}
      {tab === 'overviews' && <OverviewsTab auth={auth} />}
      {tab === 'help-desk' && <HelpDeskTab auth={auth} />}
    </div>
  );
}

export default OrganisationLicensingAndBillingPage;
